module.exports = __webpack_public_path__ + "static/media/chevron-down-blue.6711f6da.svg";